let pendingApprovalsFocus = false;

export function requestPendingApprovalsFocus() {
  pendingApprovalsFocus = true;
}

export function consumePendingApprovalsFocus() {
  const v = pendingApprovalsFocus;
  pendingApprovalsFocus = false;
  return v;
}

/** YYYY-MM-DD — next ReportDailyPage mount picks this as selected date */
let reportDailyInitialDate = null;

export function requestReportDailyDate(dateKey) {
  reportDailyInitialDate = typeof dateKey === 'string' && dateKey ? dateKey : null;
}

export function consumeReportDailyInitialDate() {
  const v = reportDailyInitialDate;
  reportDailyInitialDate = null;
  return v;
}

/** YYYY-Www — next ReportWeeklyPage mount picks this ISO week */
let reportWeeklyInitialWeek = null;

export function requestReportWeeklyForDate(dateKey) {
  if (typeof dateKey !== 'string' || !dateKey) {
    reportWeeklyInitialWeek = null;
    return;
  }
  const d = new Date(`${dateKey}T00:00:00`);
  if (Number.isNaN(d.getTime())) {
    reportWeeklyInitialWeek = null;
    return;
  }
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
  reportWeeklyInitialWeek = `${date.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
}

export function consumeReportWeeklyInitialWeek() {
  const v = reportWeeklyInitialWeek;
  reportWeeklyInitialWeek = null;
  return v;
}

/** Expenses overview: { window: 'day'|'week'|'month', anchorDate: 'Y-m-d' } */
let expensesSummaryPrefs = null;

export function requestExpensesSummaryPrefs(prefs) {
  if (!prefs || typeof prefs !== 'object') {
    expensesSummaryPrefs = null;
    return;
  }
  expensesSummaryPrefs = {
    window: prefs.window,
    anchorDate: prefs.anchorDate,
  };
}

export function consumeExpensesSummaryPrefs() {
  const v = expensesSummaryPrefs;
  expensesSummaryPrefs = null;
  return v;
}

/** Add expense form: { category: 'boss'|'staff'|'office' } */
let expensesAddPrefs = null;

export function requestExpensesAddPrefs(prefs) {
  if (!prefs || typeof prefs !== 'object') {
    expensesAddPrefs = null;
    return;
  }
  expensesAddPrefs = { category: prefs.category };
}

export function consumeExpensesAddPrefs() {
  const v = expensesAddPrefs;
  expensesAddPrefs = null;
  return v;
}
